module.exports = __webpack_public_path__ + "static/media/61 - PPI Swiss dan Liechstenstein.f5c442af.jpg";